import React, {PropsWithRef, useContext} from 'react';
import {Redirect, Route, RouteProps} from 'react-router-dom';
import {AuthContext} from "./AuthProvider";
import {UserRole} from "../redux/types";
import {Snackbar} from "@material-ui/core";
import {Alert, AlertTitle} from "@material-ui/lab";

export function PrivateRoute({
                                 children,
                                 authorizedRole,
                                 ...rest
                             }: (RouteProps & PropsWithRef<any>) & { authorizedRole: UserRole }) {

    const {userId, role} = useContext(AuthContext);

    return (
        <Route
            {...rest}
            render={({location}) => {
                if (userId && role) {
                    if (role !== authorizedRole) {
                        return (
                            <Snackbar
                                open
                                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                            >
                                <Alert severity="error">
                                    <AlertTitle>Unautorized</AlertTitle>
                                    Du hast keine Berechtigung für diesen Teil der Website
                                </Alert>
                            </Snackbar>
                        )
                    } else {
                        return children
                    }
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: {from: location}
                            }}
                        />
                    )
                }
            }}
        />
    );
}
